import { MAX_MESSAGE_LENGTH } from 'features/chat/config';

export const getChatMemberStatusText = (isOnline: boolean) => {
  return isOnline ? 'Online' : 'Offline';
};

export const scrollToBottom = (element?: HTMLElement | null) => {
  if (element) {
    element.scrollTop = element.scrollHeight - element.clientHeight;
  }
};

export function splitMessage(
  text: string,
  maxLength: number = MAX_MESSAGE_LENGTH
) {
  const messageParts = [];

  while (text.length) {
    let boundary =
      text.length <= maxLength ? text.length : text.lastIndexOf(' ', maxLength);

    if (boundary === -1) {
      boundary = maxLength;
    }
    messageParts.push(text.substring(0, boundary));
    text = text.substring(boundary + 1).trim();
  }
  return messageParts;
}

const getMediaAttachmentBorderRadius = (
  index: number,
  isLast: boolean
): string => {
  const isOnlyImage = index === 0 && isLast;
  const isFirstImage = index === 0;
  const isSecondImage = index === 1;

  if (isOnlyImage) {
    return '12px 12px 0 0';
  } else if (isFirstImage) {
    return '12px 0';
  } else if (isSecondImage) {
    return '0 12px 0 0';
  } else {
    return '0';
  }
};

export const getMediaAttachmentStyles = (index: number, isLast: boolean) => {
  const borderRadius = getMediaAttachmentBorderRadius(index, isLast);
  const flexBasis = isLast ? '100%' : 'calc(50% - var(--spacing00))';
  const aspectRatio = isLast ? '2/1' : '1/1';

  return {
    borderRadius,
    flexBasis,
    aspectRatio,
  };
};
